compiler('#page_jump', (element) => {
    function jump_to_page(page, current_page, url){
        if(!isNaN(parseInt(page)) && current_page != page) {
            location.href =  url.replace("page=page", "page=" + parseInt(page))
        }
    }

    const jump_url =  element.getAttribute('data_url');
    const current_page = element.getAttribute('data_current_page')
    element.addEventListener('focusout', () => {
        jump_to_page(element.value, current_page, jump_url)
    })
    element.addEventListener('keypress', function (event) {
        if (event.key === 'Enter') {
            event.preventDefault();
            jump_to_page(element.value, current_page, jump_url)
        }
    })
})
